import React from 'react';

import styled from 'styled-components';
import { NodeResizer } from '@reactflow/node-resizer';

import '@reactflow/node-resizer/dist/style.css';
import useMemoNode from './hooks/useMemoNode';
import { MemoBlockData } from 'types';
import { NodeProps } from 'reactflow';
import lightTheme from 'styles/themes/lightTheme';

const TextArea = styled.textarea`
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background-color: transparent;
  resize: none;
  padding: 12px;
  font-size: 13px;
  color: ${lightTheme.global.textColor};
`;

const Container = styled.div`
  position: relative;
  background-color: #feeb98;
  height: 100%;
`;

const MemoNode = ({ id, data, selected }: NodeProps<MemoBlockData>) => {
  const { value, isEditMode, textareaRef, onChange, onBlur, onResizeStart, onResizeEnd, onDoubleClick } = useMemoNode({
    id,
    data,
  });

  return (
    <>
      <NodeResizer
        minWidth={100}
        minHeight={60}
        isVisible={selected}
        handleStyle={{ height: '8px', width: '8px' }}
        onResizeStart={onResizeStart}
        onResizeEnd={onResizeEnd}
      />
      <Container onDoubleClick={onDoubleClick}>
        {isEditMode ? (
          <TextArea ref={textareaRef} className="nodrag" onBlur={onBlur} onChange={onChange} value={value} />
        ) : (
          <TextArea as="div">{value}</TextArea>
        )}
      </Container>
    </>
  );
};

export default React.memo(MemoNode);
